// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Contacts-module--fadeInAnimation--fc010";
export var iconMail = "Contacts-module--iconMail--00935";
export var iconPhone = "Contacts-module--iconPhone--620a5";
export var link = "Contacts-module--link--288e6";